var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', {
    staticClass: "publishing_item"
  }, [_c('strong', {
    staticClass: "publishing_title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm.lineBreakContents ? _c('LineBreakElement', {
    staticClass: "publishing_info",
    attrs: {
      "tag-name": _vm.tagName,
      "contents": _vm.lineBreakContents
    }
  }) : _c(_vm.tagName, {
    tag: "component",
    staticClass: "publishing_info"
  }, [_vm._t("default")], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }